
export const LANGUAGES = [
  { name: "CPP", title: 'C++', image: '/icons/cpp.png', code: "#include <iostream>\r\nusing namespace std;\r\n// chu y de ten la main ham chinh\r\nint main() {\r\n \r\n\r\n}" },
  { name: "JAVA", title: 'JAVA', image: '/icons/java.png', code: "// chu y de class la main\r\npublic class main {\r\n  public static void main(String[] args) {\r\n\r\n  }\r\n}" },
  { name: "PYTHON", title: 'PYTHON', image: '/icons/python.png', code: "" },
  { name: "C", title: 'C', image: '/icons/c.png', code: "#include <stdio.h>\r\n\r\n// chu y de ten la main ham chinh\r\nint main() {\r\n\r\n}" },
];

export const THEMES = ["vs-dark", "vs-light", "hc-black"];
